module.exports = __webpack_public_path__ + "img/Southwest_Quinoa_Bowl_Shrimp.b50a2a2e.jpg";